import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  private script?: HTMLScriptElement;

  async setUpGoogleScript(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      // Check if Google Maps is already loaded
      if (typeof google !== 'undefined' && google.maps && google.maps.Map) {
        console.log('Google Maps already loaded');
        resolve();
        return;
      }

      // Check if script is already being loaded
      const existingScript = document.getElementById('googleMapsScript');
      if (existingScript) {
        // Script is already loading, wait for it
        this.waitForGoogleMaps().then(resolve).catch(reject);
        return;
      }

      // Create and load the script
      this.script = document.createElement('script');
      this.script.type = 'text/javascript';
      this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,geometry,visualization&language=en`;
      this.script.id = 'googleMapsScript';
      this.script.async = true;

      // Handle script load success
      this.script.onload = () => {
        console.log('Google Maps script loaded successfully');
        this.waitForGoogleMaps().then(resolve).catch(reject);
      };

      // Handle script load error
      this.script.onerror = (error) => {
        console.error('Failed to load Google Maps script:', error);
        reject(new Error('Failed to load Google Maps script'));
      };

      // Append script to head (not body for better performance)
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(this.script);
    });
  }

  private waitForGoogleMaps(): Promise<void> {
    return new Promise((resolve, reject) => {
      const maxWaitTime = 10000; // 10 seconds
      const startTime = Date.now();
      
      const checkGoogleMaps = () => {
        if (typeof google !== 'undefined' && google.maps && google.maps.Map) {
          console.log('Google Maps API is ready');
          resolve();
        } else if (Date.now() - startTime > maxWaitTime) {
          console.error('Google Maps failed to load within 10 seconds');
          reject(new Error('Google Maps failed to load within timeout'));
        } else {
          setTimeout(checkGoogleMaps, 100);
        }
      };
      
      checkGoogleMaps();
    });
  }
}
